import styled from 'styled-components';
import {
  mediumFont,
  primaryColor,
  primaryHoverColor,
  primaryActiveColor,
  secondaryColor,
  secondaryHoverColor,
  secondaryActiveColor,
  whiteColor,
  whiteActiveColor,
  screenSize,
  boldFont,
} from '@app/styles';

type ButtonProps = {
  variant?:
    | 'primary'
    | 'secondary'
    | 'text'
    | 'google'
    | 'warning'
    | 'approve'
    | 'other';
  size?: 'small' | 'medium' | 'large';
  width?: string;
  color?: string;
  backgroundColor?: string;
  disabled?: boolean;
};

export const ButtonContainer = styled.button`
    min-width: 100px;
    border: 0 none;
    border-radius: 3px;
    outline: none;
    cursor: pointer;
    ${mediumFont}
    ${({ width }: ButtonProps) => {
      if (width) {
        return `width: ${width};`;
      }
    }}
    ${({ size }: ButtonProps) => {
      if (size === 'large') {
        return `
                height: 50px;
                vertical-align: middle;
            `;
      } else if (size === 'medium') {
        return `
                height: 36px;
               vertical-align: middle;
            `;
      } else if (size === 'small') {
        return `
                height: 32px;
                padding: 8px 15px;
            `;
      }
    }}
    ${({ variant, color, backgroundColor, disabled }: ButtonProps) => {
      if (disabled) {
        return `pointer-events:none;
        background-color: #EFF3FA;
        color:#483311;
        font-weight:bold;`;
      } else {
        if (variant === 'primary') {
          return `
                background-color: ${primaryColor};
                color: ${whiteColor};
                ${boldFont}
                &:hover {
                    background-color: ${primaryHoverColor};
                }
                &:active {
                    background-color: ${primaryActiveColor};
                }
            `;
        } else if (variant === 'secondary') {
          return `
                background-color: ${secondaryColor};
                color: ${whiteColor};
                &:hover {
                    background-color: ${secondaryHoverColor};
                }
                &:active {
                    background-color: ${secondaryActiveColor};
                }
            `;
        } else if (variant === 'text') {
          return `
                background-color: ${whiteColor};
                color: rgba(36, 41, 50, 0.5);
                &:hover {
                    background-color: ${whiteColor};
                }
                &:active {
                    background-color: ${whiteColor};
                }
            `;
        } else if (variant === 'google') {
          return `
                background-color: ${whiteColor};
               border: 1px solid rgba(153,153,153,0.23);
                box-shadow: 0 1px 0 0 rgba(0,0,0,0.04);
                border-radius: 4px;
                font-size: 14px;
                color: rgba(0,0,0,0.54);
                 letter-spacing: 0.22px;
                &:hover {
                    background-color: ${whiteActiveColor};
                    border:1px solid ${primaryHoverColor};
                }
                &:active {
                    background-color: ${whiteActiveColor};
                    border:1px solid ${primaryHoverColor};
                }
                @media (${screenSize.tablet}){
                    border:1px solid rgba(150, 150, 150, 0.2);
                }
            `;
        } else if (variant === 'warning') {
          return `
                background-color: rgb(254 184 44);
                color: rgb(72 52 20);
                ${boldFont}
                &:hover {
                    background:#caa612;
                }
                &:active {
                    background:#caa612;
                }
            `;
        } else if (variant === 'approve') {
          return `
                background-color: #188F71;
                color: #fff;
                ${boldFont}
                &:hover {
                    background:#00BB8C;
                }
                &:active {
                    background:#087965;
                }
            `;
        } else if (variant === 'other') {
          return `background-color:${backgroundColor};
                &:hover {
                  background-color: ${backgroundColor};
              }
                &:active {
                    background-color: ${backgroundColor};
                }
                font-weight:bold;
                color:${color}
        `;
        }
      }
    }}
`;
